import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {ApplicationState} from "../store";
import {APIState} from "../store/API/types";
import {BookmarkState} from "../store/bookmarks/types";
import {LayoutState} from "../store/layouts/types";
import {expandBookmarkPane, startBookmarkPane} from "../store/bookmarks/actions";
import {getBrowseStreamFromCamera, getLocalBounds} from "../utils";
import BookmarksPaneComponent from "../components/bookmarks/BookmarksPaneComponent";
import useGetBookmarkFrame from "../hooks/useGeBookmarkFrame";


interface Props {
    pane: number
}

const BookmarksPaneContainer: React.FC<Props> = ({pane}) => {
    const dispatch = useDispatch();

    const { cameras } = useSelector<ApplicationState, APIState>(state => state.API);
    const { bookmarks, expanded } = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
    const { checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);

    const ref = useRef<HTMLImageElement>(null);
    const refContainer = useRef<HTMLDivElement>(null);

    useGetBookmarkFrame(pane, ref);

    const cam = typeof checkedPane === 'number' ? bookmarks[checkedPane] : null;
    const error = bookmarks[pane] && bookmarks[pane].error;
    const success = bookmarks[pane] && bookmarks[pane].success;
    const fetch = bookmarks[pane] && bookmarks[pane].fetch;
    const inited = bookmarks[pane] && bookmarks[pane].inited;
    const src = bookmarks[pane] && bookmarks[pane].src;
    const name = bookmarks[pane] && bookmarks[pane].camName;

    const doExpand = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (checkedPane === pane) {
            expanded === pane ? dispatch(expandBookmarkPane(null)) : dispatch(expandBookmarkPane(pane));
            return false
        }
    };

    useEffect(() => {
        if (cam && inited) {
            const { width, height } = getLocalBounds(refContainer.current);
            const { error, stream } = getBrowseStreamFromCamera(cameras, cam.id);

            if (!error && cam) {
                dispatch(startBookmarkPane({
                    pane,
                    width: Math.floor(width),
                    height: Math.floor(height),
                    camId: cam.id,
                    url: cam.url,
                    timeBounds: cam.timeBounds,
                    streamId: stream.stream_id
                }));
            }
        }
    }, [inited]);

    // useHeartBeatenPane(pane, src);

    return (
        <BookmarksPaneComponent     pane={pane}
                                    refContainer={refContainer}
                                    refImg={ref}
                                    src={src}
                                    name={name}
                                    error={error}
                                    success={success}
                                    fetch={fetch}
                                    inited={inited}
                                    doExpand={doExpand}
        />
    );
};

export default BookmarksPaneContainer;